import {
  IconUsers,
  IconAffiliate,
  IconBriefcase,
  IconBuildingWarehouse,
  IconHome2,
  IconFileText,
  IconDashboard,
  IconLogout,
  IconFileDescription,
  IconSettings,
  IconUserCircle,
  IconFolderSearch,
  IconDeviceDesktopDown,
  IconMail,
  IconQuestionMark,
  IconReportAnalytics,
  IconReport
} from '@tabler/icons-react';

/**
 * A mapping of icon names to their respective React components.
 *
 * @type {Object.<string, React.Component>}
 */

export const iconMap = {
  IconUsers,
  IconAffiliate,
  IconBriefcase,
  IconBuildingWarehouse,
  IconHome2,
  IconFileText,
  IconDashboard,
  IconLogout,
  IconFileDescription,
  IconSettings,
  IconUserCircle,
  IconFolderSearch,
  IconDeviceDesktopDown,
  IconMail,
  IconQuestionMark,
  IconReportAnalytics,
  IconReport
};
